import { render, staticRenderFns } from "./CustomerMultiSelect.vue?vue&type=template&id=4ba1080a&scoped=true&"
import script from "./CustomerMultiSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMultiSelect.vue?vue&type=style&index=0&id=4ba1080a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba1080a",
  null
  
)

export default component.exports